import React from 'react';

const Reservations = () => {
  return <h1>This is Reservations page.</h1>;
};

export default Reservations;
